import { Icon } from 'ht-styleguide';
import StarRating from '@components/UI/StarRating';
import { SkuBullet } from 'types/sku.types';

type SubHeaderContentTypes = {
  serviceName: string;
  cityName: string;
  serviceBullets: SkuBullet[];
  ratingAttributes: {
    rating: number;
    ratingCount: number;
  };
  onRatingClick: BaseAnyFunction | null;
};

const SubHeaderContent = ({ serviceName, cityName, serviceBullets, ratingAttributes, onRatingClick }: SubHeaderContentTypes) => (
  <div className="paddingX-tiny">
    <h1 className="h2">
      {cityName} {serviceName}
    </h1>
    {ratingAttributes && (
      <StarRating
        size="sm"
        onClick={onRatingClick}
        stars={ratingAttributes.rating}
        count={ratingAttributes.ratingCount}
        className="paddingY-small2"
      />
    )}
    <h5 className="paddingBottom-small1">Service Includes</h5>
    {serviceBullets.map(bullet => (
      <div className="flex alignItemsCenter paddingBottom-small1" key={bullet.bullet}>
        <Icon name="checkmark-v2" className="htTealGreen paddingRight-small1" />
        <p className="p1">{bullet.bullet}</p>
      </div>
    ))}
  </div>
);

export default SubHeaderContent;
